function scrollDown() {
	const header = document.getElementById('header');

	if (!header) return;

	window.addEventListener('scroll', () => {
		if (window.scrollY > 100) {
			header.classList.add('scrolled-down');
		} else {
			header.classList.remove('scrolled-down');
		}
	});
}

export {scrollDown};
